export default "__VITE_ASSET__198b7895__"